var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.sectionClass},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('h3',{class:[_vm.readyToPick ? 'green' : 'red']},[_vm._v(" "+_vm._s(_vm.codValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }